import { render, staticRenderFns } from "./FungsiMagangChart.vue?vue&type=template&id=4884782d&scoped=true"
import script from "./FungsiMagangChart.vue?vue&type=script&lang=js"
export * from "./FungsiMagangChart.vue?vue&type=script&lang=js"
import style0 from "./FungsiMagangChart.vue?vue&type=style&index=0&id=4884782d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884782d",
  null
  
)

export default component.exports